import React from 'react';
import {Grid} from 'semantic-ui-react';
import {defaultColumnWidth, nameColumnWidth, lastColumnWidth} from './Constants';

const DevisSeparator = ({big, medium}) => (
    <Grid.Row divided className={big ? "big sep" : medium ? "medium sep" : "sep"}> 
        <Grid.Column width={defaultColumnWidth}>  
        </Grid.Column>
        <Grid.Column width={nameColumnWidth}>
        </Grid.Column>
        <Grid.Column width={defaultColumnWidth}>
        </Grid.Column>
        <Grid.Column width={defaultColumnWidth}>
        </Grid.Column>
        <Grid.Column width={defaultColumnWidth}>
        </Grid.Column>
        <Grid.Column width={lastColumnWidth}>
        </Grid.Column>
    </Grid.Row>
);

export default DevisSeparator;


// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/DevisSeparator.jsx